module.exports = __webpack_public_path__ + "img/Group 1094four.c7247fbc.svg";